<template>
    <div class="narrowcolleft">
        <slot />
    </div>
</template>